import { Grid, Box } from '@mui/material'
import { useDispatch } from 'react-redux'
import NumberInput from '../../shared/UI/NumberInput'
import Button from '../../shared/UI/Button'
import DrawerFooter from '../../shared/UI/DrawerFooter'
import { SellHoursType } from '../../types/sell-hours-type'
import Paragraph from '../../shared/UI/Paragraph'
import { MyEntitlementResponse } from '../../types/my-entitlement-response'
import useSellRequestForm from './useSellRequestForm'
import actionsService from '../../services/actionsService'

type Props = {
  closeDrawer: () => void
  hours: SellHoursType | undefined
  requestedSellHours?: number
  myEntitlement?: MyEntitlementResponse
  refreshEntitlement?: () => void
  drawerType?: string
}

function SellRequest({
  closeDrawer,
  hours,
  myEntitlement = undefined,
  requestedSellHours = 0,
  refreshEntitlement,
  drawerType,
}: Props) {
  const dispatch = useDispatch()

  const {
    numberOfHours,
    fieldsTouched,
    submitLoading,
    onSubmit,
    handleNumberInputChange,
    maxToSell,
    disableSubmitButton,
  } = useSellRequestForm(
    dispatch,
    closeDrawer,
    refreshEntitlement,
    hours,
    myEntitlement,
    requestedSellHours
  )

  return (
    <Grid
      component="form"
      onSubmit={(e: React.FormEvent<HTMLFormElement>) => {
        actionsService.userAnalytics
          .postEvent('UIClickEvent', 'MyExtrasSellSubmitClick', window.location.pathname, window.location.hostname)
          .catch((error: unknown) => console.error('Analytics tracking error:', error))
        onSubmit(e)
      }}
    >
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Paragraph>
            <span style={{ fontWeight: 'bold' }}>Please Note: </span>
            When selling annual leave, you can only sell from your remaining base entitlement (plus additional service). Purchased holidays are excluded, as these are only charged once used.
          </Paragraph>
        </Grid>
        <Grid item xs={12}>
          <Box>
            <NumberInput
              label="Available hours to sell"
              id="number-of-hours-to-sell"
              max={maxToSell}
              value={numberOfHours}
              fullWidth
              onChange={value => handleNumberInputChange(value ?? 0)}
              showMaxValue
              error={fieldsTouched.hours && Number(numberOfHours) < 1}
              data-testid="MyExtras-Buy-InputBtn"
            />
          </Box>
        </Grid>
      </Grid>
      <DrawerFooter>
        <Button
          color="secondary"
          label="Cancel"
          onClick={() => {
            actionsService.userAnalytics
              .postEvent('UIClickEvent', 'MyExtrasSellCancelClick', window.location.pathname, window.location.hostname)
              .catch((error: unknown) => console.error('Analytics tracking error:', error))
            closeDrawer()
          }}
          dataTestId={`MyExtras-${drawerType}-CancelBtn`}
        />
        <Button
          label="Submit"
          type="submit"
          disabled={disableSubmitButton()}
          loading={submitLoading}
          dataTestId={`MyExtras-${drawerType}-SubmitBtn`}
        />
      </DrawerFooter>
    </Grid>
  )
}

export default SellRequest
